import { compose } from 'ramda';
import { firstMatch } from 'yafrpl/strings';

import { compact, pathOr } from '../../../../helpers/compact';
import { CommonSliceType } from '../../../../types/slice';

export const parseUid = compose(firstMatch(/(\d+)$/), pathOr('', 'frame.url'));

export const socialMedia = ({ primary }) =>
  compact({
    type: CommonSliceType.SOCIAL_MEDIA,
    uid: parseUid(primary),
  });
